import UnstyledPicture from "components/Picture";
import { BREAKPOINT } from "utils/styles";
import { InView } from "react-intersection-observer";
import { BORDER_RADIUS_LARGE, COLORS } from "utils/styles";
import EditLink from "components/EditLink";

import styled from "styled-components";

const StyledPostContainer = styled.div`
  position: relative;
  margin: ${({ noMargin }) => (noMargin ? "0" : "5em auto")};

  opacity: ${({ anyPostIsFocused, postIsFocused }) => {
    if (anyPostIsFocused) {
      return postIsFocused ? "1" : ".25";
    }
    return 1;
  }};
  transition: all 350ms ease-out;
`;

export const PostContainer = (props) => {
  const handleInViewChange = (inView, entry) => {
    if (!props.shouldTrackInsights) return;
    if (!props.onInsightPostEnterView) return;
    props.onInsightPostEnterView(inView);
  };

  return (
    <InView
      as={StyledPostContainer}
      id={props.id}
      noMargin={props.noMargin}
      className={props.className}
      onChange={handleInViewChange}
      anyPostIsFocused={props.anyPostIsFocused}
      postIsFocused={props.postIsFocused}
      threshold={0.85}
    >
      {props.children}
      <EditLink filePath={props.filePath} />
    </InView>
  );
};

export const Content = styled.div`
  ${BORDER_RADIUS_LARGE};
  font-size: 1.5rem;
  line-height: 1.2;
  padding: ${({ noPadding }) => (noPadding ? "0" : "1em")};
  box-shadow: 0px 0px 20px 0px ${COLORS.GRAY};
  overflow: hidden;
  margin: 0 auto;
  max-width: 500px;
  position: relative;

  .has-insights &::before {
    content: " ";
    // Disabling the arrows for now - we may want to bring them back.
    // Will leave this decision up to the designer
    display: none;
    position: absolute;
    top: calc(50% - 72px);
    left: calc(-1rem - 24px);
    width: 72px;
    height: 72px;
    background-image: url(/images/feed-arrow.png);
    background-size: contain;
    background-repeat: no-repeat;

    @media ${BREAKPOINT.M} {
      display: none;
    }
  }
`;

export const Picture = styled(UnstyledPicture)`
  img {
    ${BORDER_RADIUS_LARGE};
    width: 100%;
    box-shadow: 0px 0px 20px 0px ${COLORS.GRAY};
  }
`;

export const PlayerContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  // margin-bottom: -20px;
`;
